import { Text } from "@ds/react";
import styled from "styled-components/macro";

export const Message = styled(Text)({
  display: "block",
  lineHeight: "20px",
  fontWeight: 500,
});
